import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAxiosPost from "../../hooks/useAxiosPost";
import TailSpinLoader from "../Items/Loaders/TailSpinLoader";
import NetwalaPagination from "../Items/Pagination/NetwalaPagination";
import SingleConnectionInvoiceCard from "./cards/SingleInvoiceCard";
const ConnectionInvoicesComponent = () => {
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ConnectionUserDetailsProp>(
    "invoices/getInvoicesByConnection"
  );
  const [invoices, setInvoices] = useState<ConnectionInvoice[]>([]);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pagination, setPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 50,
  });

  const { intPkConnectionID } = useParams();
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const {
        currentPage: apiCurrentPage,
        nextPage,
        pageSize: responsePageSize,
        previousPage,
        totalCount,
        totalPages,
        invoices,
      } = data;
      setPagination({
        currentPage: apiCurrentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        pageSize: responsePageSize,
      });
      setInvoices(invoices || []);
      // Don't update state from API response - we control that from user actions
    }
  }, [apiResponse]);

  useEffect(() => {
    postApiData({
      intPkConnectionID: Number(intPkConnectionID),
      page: currentPage,
      pageSize,
    });
  }, [intPkConnectionID, currentPage, pageSize]);

  const handleReload = () => {
    // Reload current page - useEffect will handle the API call
    postApiData({
      intPkConnectionID: Number(intPkConnectionID),
      page: currentPage,
      pageSize,
    });
  };
  const handlePageSwitch = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    // useEffect will handle the API call
  };
  const handlePageSizeChange = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(1);
    // useEffect will handle the API call
  };
  return (
    <>
      {apiLoading === true ? (
        <TailSpinLoader />
      ) : (
        <>
          <Row gutter={[16, 16]} className="end-user-profile-container">
            {invoices.map((item) => {
              return (
                <Col key={Math.random()} span={24}>
                  <SingleConnectionInvoiceCard
                    key={Math.random()}
                    invoice={item}
                    reloadApi={handleReload}
                  />
                </Col>
              );
            })}
          </Row>
          <Row style={{ width: "100%" }}>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                marginBottom: "20px",
              }}
              span={24}
            >
              <NetwalaPagination
                pagination={pagination}
                handlePageSwitch={handlePageSwitch}
                handlePageSizeChange={handlePageSizeChange}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
export default ConnectionInvoicesComponent;
